module.exports = __webpack_public_path__ + "/images/cover-acompanamos-embarazo-fr.ec3f9b0.webp";